<div
  class="alert-history-overlay"
  *ngIf="open"
  (click)="onOverlayClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="alert-history-title"
>
  <div class="alert-history-sheet" (click)="$event.stopPropagation()">
    <div class="alert-history-header">
      <div class="alert-history-title-row">
        <span class="alert-history-bell" aria-hidden="true">🔔</span>
        <h2 id="alert-history-title">アラート履歴</h2>
      </div>
      <div class="alert-history-header-right">
        <label class="alert-history-filter">
          <input type="checkbox" [(ngModel)]="unreadOnly" />
          <span>未読のみ</span>
        </label>
        <button type="button" class="alert-history-close" (click)="close()" aria-label="閉じる">✕</button>
      </div>
    </div>
    <div class="alert-history-body">
      <p *ngIf="displayedRows.length === 0" class="alert-history-empty">データがありません</p>
      <div
        *ngFor="let row of displayedRows"
        class="alert-history-row"
        [class.alert-history-row--unread]="!row.isRead"
        (click)="onRowClick(row)"
        [attr.role]="!row.isRead ? 'button' : 'listitem'"
        [attr.tabindex]="!row.isRead ? 0 : null"
        (keydown.enter)="onRowClick(row)"
        (keydown.space)="$event.preventDefault(); onRowClick(row)"
      >
        <div class="alert-row-avatar" aria-hidden="true"></div>
        <div class="alert-row-main">
          <div class="alert-row-line1">
            <span class="alert-row-name">{{ row.patientName }}</span>
            <span class="alert-row-suffix"> さんにアラートが発生しました。</span>
          </div>
          <div class="alert-row-time">{{ row.alertTime }}</div>
        </div>
        <span class="alert-row-badge alert-row-badge--unread" *ngIf="!row.isRead">未読</span>
        <span class="alert-row-badge alert-row-badge--read" *ngIf="row.isRead">既読</span>
      </div>
    </div>
  </div>
</div>
